import state from './orphan.state'
import mutations from './orphan.mutations'
import actions from './orphan.actions'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
